import {flowRight} from 'lodash-es'

// Components
import BlogDetailsComponent from './BlogDetails.component'

// HOCs
import {withHooks, withLayout} from '~/hocs'

// Util
import {getSrcSet} from '~/utils/getProductCardSrcSetAndSizes.util'

// Constants
import {APP_URL} from '~/constants/app.constant'
import {BLOG_DETAILS} from '~/constants/pages.constant'

const useHooks = (props) => {
  const {
    path,
    data,
  } = props

  const {
    blog: {
      acf,
      ...restBlog
    },
  } = data

  const blog = {
    ...acf,
    ...restBlog,
  }

  const recentProperties = data.recentProperties.edges.map(({node}) => {
    const {
      acf: nodeAcf,
      ...rest
    } = node

    const publicId = nodeAcf.thumbnail.url.substring(nodeAcf.thumbnail.url.indexOf('/v'))

    nodeAcf.thumbnail.srcSet = getSrcSet([
      [
        `https://res.cloudinary.com/ngabds/images/f_auto,q_auto,w_70,h_70,c_fill${publicId}`,
        '70w',
      ],
      [
        `https://res.cloudinary.com/ngabds/images/f_auto,q_auto,w_140,h_140,c_fill${publicId}`,
        '140w',
      ],
    ])
    nodeAcf.thumbnail.sizes = '70px'
    nodeAcf.thumbnail.url = `https://res.cloudinary.com/ngabds/images/f_auto,q_auto,w_70,h_70,c_fill${publicId}`

    return {
      ...nodeAcf,
      ...rest,
    }
  })

  const latestBlogList = data.latestBlogList.edges.map(({node}) => {
    const {
      acf: nodeAcf,
      ...rest
    } = node

    const publicId = nodeAcf.thumbnail.url.substring(nodeAcf.thumbnail.url.indexOf('/v'))

    nodeAcf.thumbnail.srcSet = getSrcSet([
      [
        `https://res.cloudinary.com/ngabds/images/f_auto,q_auto,w_60,h_60,c_fill${publicId}`,
        '60w',
      ],
      [
        `https://res.cloudinary.com/ngabds/images/f_auto,q_auto,w_120,h_120,c_fill${publicId}`,
        '120w',
      ],
    ])
    nodeAcf.thumbnail.sizes = '60px'
    nodeAcf.thumbnail.url = `https://res.cloudinary.com/ngabds/images/f_auto,q_auto,w_60,h_60,c_fill${publicId}`

    return {
      ...nodeAcf,
      ...rest,
    }
  })

  const fullUrl = `${APP_URL}${path}`

  return {
    blog,
    fullUrl,
    recentProperties,
    latestBlogList,
  }
}

const BlogDetailsTemplate = flowRight(
  withHooks(useHooks),
  withLayout({pageName: BLOG_DETAILS}),
)(BlogDetailsComponent)

export default BlogDetailsTemplate
